var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_16414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 21.3333L16.0001 16L10.6667 21.3333",
    stroke: "#374151",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16V28",
    stroke: "#374151",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1866 24.5201C28.4871 23.8112 29.5144 22.6893 30.1064 21.3316C30.6985 19.974 30.8216 18.4578 30.4562 17.0224C30.0909 15.587 29.2579 14.3142 28.0888 13.4047C26.9198 12.4953 25.4811 12.0011 23.9999 12.0001H22.3199C21.9164 10.4391 21.1642 8.98992 20.1199 7.76146C19.0756 6.53301 17.7664 5.55727 16.2907 4.90762C14.8151 4.25796 13.2113 3.95129 11.6001 4.01065C9.98886 4.07002 8.41204 4.49387 6.98818 5.25036C5.56433 6.00685 4.3305 7.07628 3.37944 8.37825C2.42839 9.68022 1.78487 11.1809 1.49725 12.7673C1.20964 14.3538 1.28542 15.9848 1.7189 17.5378C2.15238 19.0908 2.93227 20.5253 3.99995 21.7335",
    stroke: "#374151",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 21.3333L16.0001 16L10.6667 21.3333",
    stroke: "#374151",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_16414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1d11f861ce289f91a125627af0fb1725.svg";
export { ForwardRef as ReactComponent };